import {
    ADD_CUSTOMER_PAYMENT_IMPACT_REQUEST,
    ADD_CUSTOMER_PAYMENT_IMPACT_SUCCESS,
    ADD_CUSTOMER_PAYMENT_IMPACT_ERROR
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");



export const addCustomerPaymentImpact = (token, data) => (dispatch) => {
    dispatch({ type: ADD_CUSTOMER_PAYMENT_IMPACT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/customerpaymentimpact`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {payment_header_id: data}
    })

        .then((response) => {
            return dispatch({ type: ADD_CUSTOMER_PAYMENT_IMPACT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_CUSTOMER_PAYMENT_IMPACT_ERROR,
                payload: error.response,
            });
        });
};
